import dayjs from 'dayjs';
import { ISchedulingHistory } from 'app/shared/model/scheduling-history.model';
import { IGasSupply } from 'app/shared/model/gas-supply.model';
import { IUser } from 'app/shared/model/user.model';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';
import { SchedulingType } from 'app/shared/model/enumerations/scheduling-type.model';
import { SchedulingMethod } from 'app/shared/model/enumerations/scheduling-method.model';
import { Status } from 'app/shared/model/enumerations/scheduling-status.model';

export interface IScheduling {
  id?: number;
  description?: string | null;
  type?: SchedulingType;
  method?: SchedulingMethod;
  status?: Status;
  startTime?: string;
  endTime?: string;
  schedulingHistories?: ISchedulingHistory[] | null;
  gasSupplies?: IGasSupply[] | null;
  user?: IUser | null;
  userEmail?: string | null;
  createdBy?: string | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<IScheduling> = {};
